import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const getAffiliateProgramDetailsApi = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.PAYMENT_GATEWAY.GET_AFFILIATE_PROGRAM_DETAILS,
            method: 'get',
            data: data,
        })
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 